import { gql } from '@apollo/client';

export const GET_USER_ESTATES = gql`
  query {
    getUserEstates {
      id
      legalId
      title
      address
      description
      status
      isVerified
      isExclusive
      pricing {
        price
        administrationPrice
      }
      latitude
      longitude
      type
      media {
        id
        uri
        format
        isPrincipal
      }
      characteristics {
        amountOfBedrooms
        amountOfBathrooms
        amountOfParkings
        antiqueness
        area
        stratum
        hasNaturalGas
        hasStudy
        hasServiceRoom
        hasJacuzzi
        hasIndoorGarden
        hasHeating
        hasFirePlace
        hasElevator
        hasGym
        hasSwimmingPool
        hasBbqZones
        hasBasketField
        hasSoccerField
        hasComunalLiving
        hasChildrenZones
        hasTennisField
        hasSquashField
        hasSauna
        hasGreenZones
        hasGarden
        isFurnished
        petsAllowed
        deposit
        hasLaundryZones
        hasSafetyDoor
        hasTvSurveillance
        hasAlarm
        hasTerrace
        hasBalcony
        hasYard
      }
      appointmentEstateInformation {
        isLandlordConfirmationNeeded
        baseVisitConsiderations
      }
    }
  }
`;
